export default __webpack_public_path__ + "static/media/home-container.5e1b70fb.webp";